<template>
  <span>{{ value }}s</span>
</template>

<script>
import BaseControlMixin from '@/components/controls/mixins/BaseControl';

export default {
  name: 'SecondsDisplayField',
  mixins: [
    BaseControlMixin,
  ],
  computed: {
    value() {
      return Math.floor(this.getSingleVar.value / 1000);
    },
  },
};
</script>

<style scoped>

</style>
